/**
 * Map common WP pages to templates.
 * Values match page template filename in WP.
 *
 * Map common WP paths to their page templates here.
 */

/**
 * Common mappings of specific page to specific template.
 */
/**
 * Custom page views to be mapped to template names.
 */
import EventIndexPage from 'components/EventIndex'
import Page from '../../components/Page/Page'
import SectionedPage from '../../components/SectionedPage'

/**
 * Mapping of page template names to components.
 * If you want template-about.php to use <About/> component:
 * 'template-about.php' : 'About'
 */
export const pageTemplatesToComponents = {
  '': Page,
  default: Page,
  'templates/template-sectioned.php': SectionedPage,
  'templates/template-events.php': EventIndexPage,
}

export default {
  pageTemplatesToComponents,
}
